import {
  setupAsListContainer2ar7us17v5abw as setupAsListContainer,
  get_asListItemslfszm1amipl as get_asListItem,
  shownWhen3t7othivfr11 as shownWhen,
} from './direct/modifiers.commonHtml.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  reactive2xic0rufq5s8n as reactive,
  ReactiveLoadings35224pps2d9 as ReactiveLoading,
} from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { checkIndexOverflow3frtmheghr0th as checkIndexOverflow } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  LateInitSignal30crwrg540xyy as LateInitSignal,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  get_native16zxqjg6lrtlz as get_native,
  Job$cancel$ref2r8rkxbnqcz6i as Job$cancel$ref,
} from './NativeElement.commonHtml.mjs';
import {
  get_animationsEnabled25ujr8oia8gbs as get_animationsEnabled,
  set_animationsEnabled1ac1lbh50s602 as set_animationsEnabled,
} from './Element.ext.js.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { delayp0o4nsccwai as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { get_theme90wn9glxu60a as get_theme } from './Element.ext.mjs';
import { _Duration___get_inWholeMilliseconds__impl__msfiry33sjnw92ish9p as _Duration___get_inWholeMilliseconds__impl__msfiry } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { KiteUiCoroutineScopeHelpers25rj47zs39igb as KiteUiCoroutineScopeHelpers } from './KiteUiCoroutineScopeHelpers.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function renderListExpensive(_this__u8e3s4, items, beforeModifier, render) {
  setupAsListContainer(_this__u8e3s4);
  reactive(_this__u8e3s4, VOID, ($this$reactive) => {
    _this__u8e3s4.clearChildren_eufjq4_k$();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = $this$reactive.invoke_r7m7el_k$(items).iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      render(get_asListItem(beforeModifier(_this__u8e3s4, element)), element);
    }
    return Unit_instance;
  });
}
function forEach(_this__u8e3s4, items, beforeListModifier, render) {
  var tmp;
  if (beforeListModifier === VOID) {
    tmp = forEach$lambda;
  } else {
    tmp = beforeListModifier;
  }
  beforeListModifier = tmp;
  return renderListExpensive(_this__u8e3s4, items, beforeListModifier, render);
}
function forEachAnimated(_this__u8e3s4, items, preHidingModifiers, render) {
  var tmp;
  if (preHidingModifiers === VOID) {
    tmp = forEachAnimated$lambda;
  } else {
    tmp = preHidingModifiers;
  }
  preHidingModifiers = tmp;
  return renderListExpensiveAnimating(_this__u8e3s4, items, preHidingModifiers, render);
}
function forEachUpdating(_this__u8e3s4, items, placeholdersWhileLoading, beforeListModifier, render) {
  placeholdersWhileLoading = placeholdersWhileLoading === VOID ? 5 : placeholdersWhileLoading;
  var tmp;
  if (beforeListModifier === VOID) {
    tmp = forEachUpdating$lambda;
  } else {
    tmp = beforeListModifier;
  }
  beforeListModifier = tmp;
  return renderListPositional(_this__u8e3s4, items, placeholdersWhileLoading, 32, beforeListModifier, render);
}
function renderListKeyed(_this__u8e3s4, items, id, animate, beforeModifier, render) {
  animate = animate === VOID ? true : animate;
  var tmp;
  if (beforeModifier === VOID) {
    tmp = renderListKeyed$lambda;
  } else {
    tmp = beforeModifier;
  }
  beforeModifier = tmp;
  if (animate) {
    renderListKeyedAnimated(_this__u8e3s4, items, id, beforeModifier, render);
  } else {
    renderListKeyedNoAnimation(_this__u8e3s4, items, id, beforeModifier, render);
  }
}
function renderList(_this__u8e3s4, items, placeholders, poolCap, beforeModifier, render) {
  poolCap = poolCap === VOID ? 32 : poolCap;
  renderListPositional(_this__u8e3s4, items, placeholders, poolCap, beforeModifier, render);
}
function renderListExpensive_0(_this__u8e3s4, items, animate, beforeModifier, render) {
  var tmp;
  if (beforeModifier === VOID) {
    tmp = renderListExpensive$lambda;
  } else {
    tmp = beforeModifier;
  }
  beforeModifier = tmp;
  if (animate) {
    renderListExpensiveAnimating(_this__u8e3s4, items, beforeModifier, render);
  } else {
    renderListExpensive(_this__u8e3s4, items, beforeModifier, render);
  }
}
function renderListExpensiveAnimating(_this__u8e3s4, items, beforeModifier, render) {
  var tmp;
  if (beforeModifier === VOID) {
    tmp = renderListExpensiveAnimating$lambda;
  } else {
    tmp = beforeModifier;
  }
  beforeModifier = tmp;
  setupAsListContainer(_this__u8e3s4);
  var old = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  reactive(_this__u8e3s4, VOID, ($this$reactive) => {
    var new_0 = $this$reactive.invoke_r7m7el_k$(items);
    var oldPos = 0;
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var _iterator__ex2g4s = new_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var index_0 = checkIndexOverflow(_unary__edvuaz);
      var matchIndex = -1;
      var inductionVariable = oldPos;
      var last = old.get_size_woubt6_k$();
      if (inductionVariable < last)
        $l$loop: do {
          var checkIndex = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (equals(old.get_c1px32_k$(checkIndex).data_1, item)) {
            old.get_c1px32_k$(checkIndex).show_58bemr_k$();
            matchIndex = checkIndex;
            break $l$loop;
          }
        }
         while (inductionVariable < last);
      if (!(matchIndex === -1)) {
        var inductionVariable_0 = oldPos;
        var last_0 = matchIndex;
        if (inductionVariable_0 < last_0)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            old.get_c1px32_k$(i).hide_o8jt72_k$();
          }
           while (inductionVariable_0 < last_0);
        oldPos = matchIndex + 1 | 0;
      } else {
        var shown = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.produceExactlyOneView' call
        // Inline function 'com.lightningkite.kiteui.views.produceAtMostOneView' call
        // Inline function 'com.lightningkite.kiteui.views.produceAtMostOneUnsafe' call
        var this_0 = atIndex(_this__u8e3s4, oldPos);
        var output = {_v: null};
        var writer = new (renderListExpensiveAnimating$2$1())(this_0, output);
        var tmp = get_asListItem(beforeModifier(writer, item));
        render(shownWhen(tmp, VOID, VOID, renderListExpensiveAnimating$lambda$lambda(shown)), item);
        var tmp0_elvis_lhs = output._v;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Produced no elements at this layer, but expected one.');
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var result = tmp_0;
        old.add_dl6gt3_k$(oldPos, new (Cell())(index_0, null, item, old, _this__u8e3s4, result, shown));
        shown.set_value_v1vabv_k$(true);
        oldPos = oldPos + 1 | 0;
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = old.subList_xle3r2_k$(oldPos, old.get_size_woubt6_k$()).iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s_0.next_20eer_k$();
      element.hide_o8jt72_k$();
    }
    return Unit_instance;
  });
}
function renderListPositional(_this__u8e3s4, items, placeholders, poolCap, beforeModifier, render) {
  setupAsListContainer(_this__u8e3s4);
  var currentViews = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var currentView = _this__u8e3s4;
  // Inline function 'com.lightningkite.reactive.context.reactive' call
  var wasLoadingLastTime = {_v: false};
  reactive(_this__u8e3s4, VOID, ($this$reactive) => {
    var tmp;
    try {
      var itemList = $this$reactive.invoke_r7m7el_k$(items);
      // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
      var this_0 = currentView;
      var tmp_0 = get_native(this_0).element_1;
      var tmp0_safe_receiver = tmp_0 instanceof HTMLElement ? tmp_0 : null;
      var tmp_1;
      if (tmp0_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
        var this_1 = tmp0_safe_receiver;
        var animate = get_animationsEnabled();
        try {
          if (animate) {
            set_animationsEnabled(false);
            // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp_2 = this_1.__suppressMutationObserverClass;
            var tmp0_elvis_lhs = tmp_2 instanceof ArrayList() ? tmp_2 : null;
            var tmp_3;
            if (tmp0_elvis_lhs == null) {
              // Inline function 'kotlin.run' call
              var n = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
              // Inline function 'kotlin.js.asDynamic' call
              this_1.__suppressMutationObserverClass = n;
              tmp_3 = n;
            } else {
              tmp_3 = tmp0_elvis_lhs;
            }
            var e = tmp_3;
            this_1.classList.add('notransition');
            var tmp1_elvis_lhs = this_1.getAttribute('class');
            e.add_utx5q5_k$(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
          }
          var oldSize = currentViews.get_size_woubt6_k$();
          if (currentViews.get_size_woubt6_k$() < itemList.get_size_woubt6_k$()) {
            // Inline function 'kotlin.repeat' call
            var times = itemList.get_size_woubt6_k$() - currentViews.get_size_woubt6_k$() | 0;
            var inductionVariable = 0;
            if (inductionVariable < times)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var newProp = LateInitSignal().new_com_lightningkite_reactive_core_LateInitSignal_q590qj_k$();
                // Inline function 'com.lightningkite.reactive.extensions.value' call
                var value = itemList.get_c1px32_k$(currentViews.get_size_woubt6_k$());
                newProp.valueSet_aujvv6_k$(value);
                render(get_asListItem(beforeModifier(_this__u8e3s4)), newProp);
                currentViews.add_utx5q5_k$(newProp);
              }
               while (inductionVariable < times);
          }
          var ch = currentView.get_children_4cwbp4_k$();
          var inductionVariable_0 = 0;
          // Inline function 'kotlin.math.min' call
          var b = itemList.get_size_woubt6_k$();
          var last = Math.min(oldSize, b);
          if (inductionVariable_0 < last)
            do {
              var index_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              ch.get_c1px32_k$(index_0).set_shown_mavbz5_k$(true);
              var tmp0 = currentViews.get_c1px32_k$(index_0);
              // Inline function 'com.lightningkite.reactive.extensions.value' call
              var value_0 = itemList.get_c1px32_k$(index_0);
              tmp0.valueSet_aujvv6_k$(value_0);
            }
             while (inductionVariable_0 < last);
          var inductionVariable_1 = itemList.get_size_woubt6_k$();
          var last_0 = currentViews.get_size_woubt6_k$();
          if (inductionVariable_1 < last_0)
            do {
              var index_1 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              ch.get_c1px32_k$(index_1).set_shown_mavbz5_k$(false);
            }
             while (inductionVariable_1 < last_0);
          var maxSlots = itemList.get_size_woubt6_k$() + poolCap | 0;
          if (currentViews.get_size_woubt6_k$() > maxSlots) {
            var inductionVariable_2 = currentViews.get_size_woubt6_k$() - 1 | 0;
            if (0 <= inductionVariable_2)
              $l$loop: do {
                var index_2 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + -1 | 0;
                if (currentViews.get_size_woubt6_k$() <= maxSlots)
                  break $l$loop;
                if (index_2 >= itemList.get_size_woubt6_k$()) {
                  currentView.removeChild_mjbjbk_k$(index_2);
                  currentViews.removeAt_6niowx_k$(index_2);
                }
              }
               while (0 <= inductionVariable_2);
          }
        }finally {
          if (animate) {
            var tmp_4 = window;
            tmp_4.setTimeout(() => {
              // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
              var this_0 = this_1;
              // Inline function 'kotlin.js.asDynamic' call
              var tmp = this_0.__suppressMutationObserverClass;
              var tmp0_elvis_lhs = tmp instanceof ArrayList() ? tmp : null;
              var tmp_0;
              if (tmp0_elvis_lhs == null) {
                // Inline function 'kotlin.run' call
                var n = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
                // Inline function 'kotlin.js.asDynamic' call
                this_0.__suppressMutationObserverClass = n;
                tmp_0 = n;
              } else {
                tmp_0 = tmp0_elvis_lhs;
              }
              var e = tmp_0;
              this_1.classList.remove('notransition');
              var tmp1_elvis_lhs = this_0.getAttribute('class');
              e.add_utx5q5_k$(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
              return Unit_instance;
            }, 100);
            set_animationsEnabled(true);
          }
        }
        tmp_1 = Unit_instance;
      }
      if (tmp_1 == null) {
        var oldSize_0 = currentViews.get_size_woubt6_k$();
        if (currentViews.get_size_woubt6_k$() < itemList.get_size_woubt6_k$()) {
          // Inline function 'kotlin.repeat' call
          var times_0 = itemList.get_size_woubt6_k$() - currentViews.get_size_woubt6_k$() | 0;
          var inductionVariable_3 = 0;
          if (inductionVariable_3 < times_0)
            do {
              var index_3 = inductionVariable_3;
              inductionVariable_3 = inductionVariable_3 + 1 | 0;
              var newProp_0 = LateInitSignal().new_com_lightningkite_reactive_core_LateInitSignal_q590qj_k$();
              // Inline function 'com.lightningkite.reactive.extensions.value' call
              var value_1 = itemList.get_c1px32_k$(currentViews.get_size_woubt6_k$());
              newProp_0.valueSet_aujvv6_k$(value_1);
              render(get_asListItem(beforeModifier(_this__u8e3s4)), newProp_0);
              currentViews.add_utx5q5_k$(newProp_0);
            }
             while (inductionVariable_3 < times_0);
        }
        var ch_0 = currentView.get_children_4cwbp4_k$();
        var inductionVariable_4 = 0;
        // Inline function 'kotlin.math.min' call
        var b_0 = itemList.get_size_woubt6_k$();
        var last_1 = Math.min(oldSize_0, b_0);
        if (inductionVariable_4 < last_1)
          do {
            var index_4 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            ch_0.get_c1px32_k$(index_4).set_shown_mavbz5_k$(true);
            var tmp0_0 = currentViews.get_c1px32_k$(index_4);
            // Inline function 'com.lightningkite.reactive.extensions.value' call
            var value_2 = itemList.get_c1px32_k$(index_4);
            tmp0_0.valueSet_aujvv6_k$(value_2);
          }
           while (inductionVariable_4 < last_1);
        var inductionVariable_5 = itemList.get_size_woubt6_k$();
        var last_2 = currentViews.get_size_woubt6_k$();
        if (inductionVariable_5 < last_2)
          do {
            var index_5 = inductionVariable_5;
            inductionVariable_5 = inductionVariable_5 + 1 | 0;
            ch_0.get_c1px32_k$(index_5).set_shown_mavbz5_k$(false);
          }
           while (inductionVariable_5 < last_2);
        var maxSlots_0 = itemList.get_size_woubt6_k$() + poolCap | 0;
        if (currentViews.get_size_woubt6_k$() > maxSlots_0) {
          var inductionVariable_6 = currentViews.get_size_woubt6_k$() - 1 | 0;
          if (0 <= inductionVariable_6)
            $l$loop_0: do {
              var index_6 = inductionVariable_6;
              inductionVariable_6 = inductionVariable_6 + -1 | 0;
              if (currentViews.get_size_woubt6_k$() <= maxSlots_0)
                break $l$loop_0;
              if (index_6 >= itemList.get_size_woubt6_k$()) {
                currentView.removeChild_mjbjbk_k$(index_6);
                currentViews.removeAt_6niowx_k$(index_6);
              }
            }
             while (0 <= inductionVariable_6);
        }
      }
      wasLoadingLastTime._v = false;
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_5;
      if ($p instanceof ReactiveLoading()) {
        var e_0 = $p;
        if (!wasLoadingLastTime._v) {
          wasLoadingLastTime._v = true;
          $l$block_0: {
            // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
            var this_2 = currentView;
            var tmp_6 = get_native(this_2).element_1;
            var tmp0_safe_receiver_0 = tmp_6 instanceof HTMLElement ? tmp_6 : null;
            var tmp_7;
            if (tmp0_safe_receiver_0 == null) {
              tmp_7 = null;
            } else {
              // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
              var this_3 = tmp0_safe_receiver_0;
              var animate_0 = get_animationsEnabled();
              try {
                if (animate_0) {
                  set_animationsEnabled(false);
                  // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
                  // Inline function 'kotlin.js.asDynamic' call
                  var tmp_8 = this_3.__suppressMutationObserverClass;
                  var tmp0_elvis_lhs_0 = tmp_8 instanceof ArrayList() ? tmp_8 : null;
                  var tmp_9;
                  if (tmp0_elvis_lhs_0 == null) {
                    // Inline function 'kotlin.run' call
                    var n_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
                    // Inline function 'kotlin.js.asDynamic' call
                    this_3.__suppressMutationObserverClass = n_0;
                    tmp_9 = n_0;
                  } else {
                    tmp_9 = tmp0_elvis_lhs_0;
                  }
                  var e_1 = tmp_9;
                  this_3.classList.add('notransition');
                  var tmp1_elvis_lhs_0 = this_3.getAttribute('class');
                  e_1.add_utx5q5_k$(tmp1_elvis_lhs_0 == null ? '' : tmp1_elvis_lhs_0);
                }
                if (placeholders <= 0) {
                  break $l$block_0;
                }
                if (currentViews.get_size_woubt6_k$() < placeholders) {
                  // Inline function 'kotlin.repeat' call
                  var times_1 = placeholders - currentViews.get_size_woubt6_k$() | 0;
                  var inductionVariable_7 = 0;
                  if (inductionVariable_7 < times_1)
                    do {
                      var index_7 = inductionVariable_7;
                      inductionVariable_7 = inductionVariable_7 + 1 | 0;
                      var newProp_1 = LateInitSignal().new_com_lightningkite_reactive_core_LateInitSignal_q590qj_k$();
                      render(get_asListItem(beforeModifier(_this__u8e3s4)), newProp_1);
                      currentViews.add_utx5q5_k$(newProp_1);
                    }
                     while (inductionVariable_7 < times_1);
                }
                var ch_1 = currentView.get_children_4cwbp4_k$();
                var inductionVariable_8 = 0;
                if (inductionVariable_8 < placeholders)
                  do {
                    var index_8 = inductionVariable_8;
                    inductionVariable_8 = inductionVariable_8 + 1 | 0;
                    ch_1.get_c1px32_k$(index_8).set_shown_mavbz5_k$(true);
                    currentViews.get_c1px32_k$(index_8).unset_qi6921_k$();
                  }
                   while (inductionVariable_8 < placeholders);
                var inductionVariable_9 = placeholders;
                var last_3 = currentViews.get_size_woubt6_k$();
                if (inductionVariable_9 < last_3)
                  do {
                    var index_9 = inductionVariable_9;
                    inductionVariable_9 = inductionVariable_9 + 1 | 0;
                    ch_1.get_c1px32_k$(index_9).set_shown_mavbz5_k$(false);
                  }
                   while (inductionVariable_9 < last_3);
              }finally {
                if (animate_0) {
                  var tmp_10 = window;
                  tmp_10.setTimeout(() => {
                    // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
                    var this_0 = this_3;
                    // Inline function 'kotlin.js.asDynamic' call
                    var tmp = this_0.__suppressMutationObserverClass;
                    var tmp0_elvis_lhs = tmp instanceof ArrayList() ? tmp : null;
                    var tmp_0;
                    if (tmp0_elvis_lhs == null) {
                      // Inline function 'kotlin.run' call
                      var n = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
                      // Inline function 'kotlin.js.asDynamic' call
                      this_0.__suppressMutationObserverClass = n;
                      tmp_0 = n;
                    } else {
                      tmp_0 = tmp0_elvis_lhs;
                    }
                    var e = tmp_0;
                    this_3.classList.remove('notransition');
                    var tmp1_elvis_lhs = this_0.getAttribute('class');
                    e.add_utx5q5_k$(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
                    return Unit_instance;
                  }, 100);
                  set_animationsEnabled(true);
                }
              }
              tmp_7 = Unit_instance;
            }
            if (tmp_7 == null) {
              if (placeholders <= 0) {
                break $l$block_0;
              }
              if (currentViews.get_size_woubt6_k$() < placeholders) {
                // Inline function 'kotlin.repeat' call
                var times_2 = placeholders - currentViews.get_size_woubt6_k$() | 0;
                var inductionVariable_10 = 0;
                if (inductionVariable_10 < times_2)
                  do {
                    var index_10 = inductionVariable_10;
                    inductionVariable_10 = inductionVariable_10 + 1 | 0;
                    var newProp_2 = LateInitSignal().new_com_lightningkite_reactive_core_LateInitSignal_q590qj_k$();
                    render(get_asListItem(beforeModifier(_this__u8e3s4)), newProp_2);
                    currentViews.add_utx5q5_k$(newProp_2);
                  }
                   while (inductionVariable_10 < times_2);
              }
              var ch_2 = currentView.get_children_4cwbp4_k$();
              var inductionVariable_11 = 0;
              if (inductionVariable_11 < placeholders)
                do {
                  var index_11 = inductionVariable_11;
                  inductionVariable_11 = inductionVariable_11 + 1 | 0;
                  ch_2.get_c1px32_k$(index_11).set_shown_mavbz5_k$(true);
                  currentViews.get_c1px32_k$(index_11).unset_qi6921_k$();
                }
                 while (inductionVariable_11 < placeholders);
              var inductionVariable_12 = placeholders;
              var last_4 = currentViews.get_size_woubt6_k$();
              if (inductionVariable_12 < last_4)
                do {
                  var index_12 = inductionVariable_12;
                  inductionVariable_12 = inductionVariable_12 + 1 | 0;
                  ch_2.get_c1px32_k$(index_12).set_shown_mavbz5_k$(false);
                }
                 while (inductionVariable_12 < last_4);
            }
          }
        }
        throw e_0;
      } else {
        if ($p instanceof Exception()) {
          var e_2 = $p;
          wasLoadingLastTime._v = false;
          tmp_5 = Unit_instance;
        } else {
          throw $p;
        }
      }
      tmp = tmp_5;
    }
    return Unit_instance;
  });
}
function renderListKeyedAnimated(_this__u8e3s4, items, id, beforeModifier, render) {
  setupAsListContainer(_this__u8e3s4);
  var old = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  reactive(_this__u8e3s4, VOID, ($this$reactive) => {
    var new_0 = $this$reactive.invoke_r7m7el_k$(items);
    var oldPos = 0;
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var _iterator__ex2g4s = new_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var index_0 = checkIndexOverflow(_unary__edvuaz);
      var matchIndex = -1;
      var inductionVariable = oldPos;
      var last = old.get_size_woubt6_k$();
      if (inductionVariable < last)
        $l$loop: do {
          var checkIndex = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (equals(old.get_c1px32_k$(checkIndex).id_1, id(item))) {
            matchIndex = checkIndex;
            break $l$loop;
          }
        }
         while (inductionVariable < last);
      if (!(matchIndex === -1)) {
        var inductionVariable_0 = oldPos;
        var last_0 = matchIndex;
        if (inductionVariable_0 < last_0)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            old.get_c1px32_k$(i).hide_o8jt72_k$();
          }
           while (inductionVariable_0 < last_0);
        oldPos = matchIndex + 1 | 0;
        // Inline function 'kotlin.let' call
        var it = old.get_c1px32_k$(matchIndex);
        it.data_1.set_value_v1vabv_k$(item);
        it.show_58bemr_k$();
      } else {
        var shown = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
        var data = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(item);
        // Inline function 'com.lightningkite.kiteui.views.produceExactlyOneView' call
        // Inline function 'com.lightningkite.kiteui.views.produceAtMostOneView' call
        // Inline function 'com.lightningkite.kiteui.views.produceAtMostOneUnsafe' call
        var this_0 = atIndex(_this__u8e3s4, oldPos);
        var output = {_v: null};
        var writer = new (renderListKeyedAnimated$1$1())(this_0, output);
        var tmp = get_asListItem(beforeModifier(writer));
        render(shownWhen(tmp, VOID, VOID, renderListKeyedAnimated$lambda$lambda(shown)), data);
        var tmp0_elvis_lhs = output._v;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Produced no elements at this layer, but expected one.');
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var result = tmp_0;
        var tmp_1 = oldPos;
        var tmp0_id = id(item);
        old.add_dl6gt3_k$(tmp_1, new (Cell())(index_0, tmp0_id, data, old, _this__u8e3s4, result, shown));
        // Inline function 'com.lightningkite.kiteui.afterTimeout' call
        var job = launch($this$reactive, VOID, VOID, renderListKeyedAnimated$lambda$slambda(1n, shown));
        Job$cancel$ref(job);
        oldPos = oldPos + 1 | 0;
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = old.subList_xle3r2_k$(oldPos, old.get_size_woubt6_k$()).iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s_0.next_20eer_k$();
      element.hide_o8jt72_k$();
    }
    return Unit_instance;
  });
}
function renderListKeyedNoAnimation(_this__u8e3s4, items, id, beforeModifier, render) {
  setupAsListContainer(_this__u8e3s4);
  var old = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  reactive(_this__u8e3s4, VOID, ($this$reactive) => {
    // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
    var this_0 = _this__u8e3s4;
    var tmp = get_native(this_0).element_1;
    var tmp0_safe_receiver = tmp instanceof HTMLElement ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
      var this_1 = tmp0_safe_receiver;
      var animate = get_animationsEnabled();
      try {
        if (animate) {
          set_animationsEnabled(false);
          // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp_1 = this_1.__suppressMutationObserverClass;
          var tmp0_elvis_lhs = tmp_1 instanceof ArrayList() ? tmp_1 : null;
          var tmp_2;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.run' call
            var n = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
            // Inline function 'kotlin.js.asDynamic' call
            this_1.__suppressMutationObserverClass = n;
            tmp_2 = n;
          } else {
            tmp_2 = tmp0_elvis_lhs;
          }
          var e = tmp_2;
          this_1.classList.add('notransition');
          var tmp1_elvis_lhs = this_1.getAttribute('class');
          e.add_utx5q5_k$(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
        }
        var new_0 = $this$reactive.invoke_r7m7el_k$(items);
        var oldPos = 0;
        // Inline function 'kotlin.collections.forEachIndexed' call
        var index = 0;
        var _iterator__ex2g4s = new_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          var index_0 = checkIndexOverflow(_unary__edvuaz);
          var matchIndex = -1;
          var inductionVariable = oldPos;
          var last = old.get_size_woubt6_k$();
          if (inductionVariable < last)
            $l$loop: do {
              var checkIndex = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              if (equals(old.get_c1px32_k$(checkIndex).id_1, id(item))) {
                matchIndex = checkIndex;
                break $l$loop;
              }
            }
             while (inductionVariable < last);
          if (!(matchIndex === -1)) {
            var inductionVariable_0 = oldPos;
            var last_0 = matchIndex;
            if (inductionVariable_0 < last_0)
              do {
                var i = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                old.get_c1px32_k$(i).hide_o8jt72_k$();
              }
               while (inductionVariable_0 < last_0);
            oldPos = matchIndex + 1 | 0;
            // Inline function 'kotlin.let' call
            var it = old.get_c1px32_k$(matchIndex);
            it.data_1.set_value_v1vabv_k$(item);
            it.show_58bemr_k$();
          } else {
            var shown = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
            var data = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(item);
            // Inline function 'com.lightningkite.kiteui.views.produceExactlyOneView' call
            // Inline function 'com.lightningkite.kiteui.views.produceAtMostOneView' call
            // Inline function 'com.lightningkite.kiteui.views.produceAtMostOneUnsafe' call
            var this_2 = atIndex(_this__u8e3s4, oldPos);
            var output = {_v: null};
            var writer = new (renderListKeyedNoAnimation$1$$inlined$withoutAnimation$1())(this_2, output);
            render(get_asListItem(beforeModifier(writer)), data);
            var tmp0_elvis_lhs_0 = output._v;
            var tmp_3;
            if (tmp0_elvis_lhs_0 == null) {
              throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Produced no elements at this layer, but expected one.');
            } else {
              tmp_3 = tmp0_elvis_lhs_0;
            }
            var result = tmp_3;
            var tmp_4 = oldPos;
            var tmp0_id = id(item);
            old.add_dl6gt3_k$(tmp_4, new (Cell())(index_0, tmp0_id, data, old, _this__u8e3s4, result, shown));
            // Inline function 'com.lightningkite.kiteui.afterTimeout' call
            var job = launch($this$reactive, VOID, VOID, renderListKeyedNoAnimation$lambda$slambda(1n, shown));
            Job$cancel$ref(job);
            oldPos = oldPos + 1 | 0;
          }
        }
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = old.subList_xle3r2_k$(oldPos, old.get_size_woubt6_k$()).iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s_0.next_20eer_k$();
          element.hide_o8jt72_k$();
        }
      }finally {
        if (animate) {
          var tmp_5 = window;
          tmp_5.setTimeout(() => {
            // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
            var this_0 = this_1;
            // Inline function 'kotlin.js.asDynamic' call
            var tmp = this_0.__suppressMutationObserverClass;
            var tmp0_elvis_lhs = tmp instanceof ArrayList() ? tmp : null;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              // Inline function 'kotlin.run' call
              var n = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
              // Inline function 'kotlin.js.asDynamic' call
              this_0.__suppressMutationObserverClass = n;
              tmp_0 = n;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }
            var e = tmp_0;
            this_1.classList.remove('notransition');
            var tmp1_elvis_lhs = this_0.getAttribute('class');
            e.add_utx5q5_k$(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
            return Unit_instance;
          }, 100);
          set_animationsEnabled(true);
        }
      }
      tmp_0 = Unit_instance;
    }
    if (tmp_0 == null) {
      var new_1 = $this$reactive.invoke_r7m7el_k$(items);
      var oldPos_0 = 0;
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index_1 = 0;
      var _iterator__ex2g4s_1 = new_1.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
        var item_0 = _iterator__ex2g4s_1.next_20eer_k$();
        var _unary__edvuaz_0 = index_1;
        index_1 = _unary__edvuaz_0 + 1 | 0;
        var index_2 = checkIndexOverflow(_unary__edvuaz_0);
        var matchIndex_0 = -1;
        var inductionVariable_1 = oldPos_0;
        var last_1 = old.get_size_woubt6_k$();
        if (inductionVariable_1 < last_1)
          $l$loop_0: do {
            var checkIndex_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            if (equals(old.get_c1px32_k$(checkIndex_0).id_1, id(item_0))) {
              matchIndex_0 = checkIndex_0;
              break $l$loop_0;
            }
          }
           while (inductionVariable_1 < last_1);
        if (!(matchIndex_0 === -1)) {
          var inductionVariable_2 = oldPos_0;
          var last_2 = matchIndex_0;
          if (inductionVariable_2 < last_2)
            do {
              var i_0 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              old.get_c1px32_k$(i_0).hide_o8jt72_k$();
            }
             while (inductionVariable_2 < last_2);
          oldPos_0 = matchIndex_0 + 1 | 0;
          // Inline function 'kotlin.let' call
          var it_0 = old.get_c1px32_k$(matchIndex_0);
          it_0.data_1.set_value_v1vabv_k$(item_0);
          it_0.show_58bemr_k$();
        } else {
          var shown_0 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
          var data_0 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(item_0);
          // Inline function 'com.lightningkite.kiteui.views.produceExactlyOneView' call
          // Inline function 'com.lightningkite.kiteui.views.produceAtMostOneView' call
          // Inline function 'com.lightningkite.kiteui.views.produceAtMostOneUnsafe' call
          var this_3 = atIndex(_this__u8e3s4, oldPos_0);
          var output_0 = {_v: null};
          var writer_0 = new (renderListKeyedNoAnimation$1$$inlined$withoutAnimation$5())(this_3, output_0);
          render(get_asListItem(beforeModifier(writer_0)), data_0);
          var tmp0_elvis_lhs_1 = output_0._v;
          var tmp_6;
          if (tmp0_elvis_lhs_1 == null) {
            throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Produced no elements at this layer, but expected one.');
          } else {
            tmp_6 = tmp0_elvis_lhs_1;
          }
          var result_0 = tmp_6;
          var tmp_7 = oldPos_0;
          var tmp0_id_0 = id(item_0);
          old.add_dl6gt3_k$(tmp_7, new (Cell())(index_2, tmp0_id_0, data_0, old, _this__u8e3s4, result_0, shown_0));
          // Inline function 'com.lightningkite.kiteui.afterTimeout' call
          var job_0 = launch($this$reactive, VOID, VOID, renderListKeyedNoAnimation$lambda$slambda_0(1n, shown_0));
          Job$cancel$ref(job_0);
          oldPos_0 = oldPos_0 + 1 | 0;
        }
      }
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_2 = old.subList_xle3r2_k$(oldPos_0, old.get_size_woubt6_k$()).iterator_jk1svi_k$();
      while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
        var element_0 = _iterator__ex2g4s_2.next_20eer_k$();
        element_0.hide_o8jt72_k$();
      }
    }
    return Unit_instance;
  });
}
function Cell$hide$slambda($milliseconds, $n, this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay($milliseconds, $completion);
    if ($n === this$0.livenessIter_1) {
      this$0.container_1.removeChild_kofmvd_k$(this$0.view_1);
      this$0.cells_1.remove_cedx0m_k$(this$0);
    }
    return Unit_instance;
  }), 1);
}
var CellClass;
function Cell() {
  if (CellClass === VOID) {
    class $ {
      constructor(oldIndex, id, data, cells, container, view, shown) {
        this.oldIndex_1 = oldIndex;
        this.id_1 = id;
        this.data_1 = data;
        this.cells_1 = cells;
        this.container_1 = container;
        this.view_1 = view;
        this.shown_1 = shown;
        this.livenessIter_1 = 0;
      }
      show_58bemr_k$() {
        this.livenessIter_1 = this.livenessIter_1 + 1 | 0;
        this.shown_1.set_value_v1vabv_k$(true);
      }
      hide_o8jt72_k$() {
        this.livenessIter_1 = this.livenessIter_1 + 1 | 0;
        var n = this.livenessIter_1;
        this.shown_1.set_value_v1vabv_k$(false);
        var tmp0 = this.container_1;
        // Inline function 'kotlin.Long.plus' call
        var this_0 = _Duration___get_inWholeMilliseconds__impl__msfiry(get_theme(this.view_1).transitionDuration_1);
        // Inline function 'com.lightningkite.kiteui.afterTimeout' call
        var milliseconds = add(this_0, fromInt(100));
        var job = launch(tmp0, VOID, VOID, Cell$hide$slambda(milliseconds, n, this));
        Job$cancel$ref(job);
      }
      toString() {
        return 'Cell(oldIndex=' + this.oldIndex_1 + ', id=' + toString_0(this.id_1) + ', data=' + toString_0(this.data_1) + ', cells=' + this.cells_1.toString() + ', container=' + this.container_1.toString() + ', view=' + this.view_1.toString() + ', shown=' + toString(this.shown_1) + ')';
      }
      hashCode() {
        var result = this.oldIndex_1;
        result = imul(result, 31) + (this.id_1 == null ? 0 : hashCode(this.id_1)) | 0;
        result = imul(result, 31) + (this.data_1 == null ? 0 : hashCode(this.data_1)) | 0;
        result = imul(result, 31) + this.cells_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.container_1) | 0;
        result = imul(result, 31) + hashCode(this.view_1) | 0;
        result = imul(result, 31) + hashCode(this.shown_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Cell()))
          return false;
        if (!(this.oldIndex_1 === other.oldIndex_1))
          return false;
        if (!equals(this.id_1, other.id_1))
          return false;
        if (!equals(this.data_1, other.data_1))
          return false;
        if (!this.cells_1.equals(other.cells_1))
          return false;
        if (!equals(this.container_1, other.container_1))
          return false;
        if (!equals(this.view_1, other.view_1))
          return false;
        if (!equals(this.shown_1, other.shown_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Cell');
    CellClass = $;
  }
  return CellClass;
}
function atIndex(_this__u8e3s4, index) {
  return new (atIndex$1())(_this__u8e3s4, index);
}
function forEach$lambda(_this__u8e3s4, it) {
  return _this__u8e3s4;
}
function forEachAnimated$lambda(_this__u8e3s4, it) {
  return _this__u8e3s4;
}
function forEachUpdating$lambda(_this__u8e3s4) {
  return _this__u8e3s4;
}
function renderListKeyed$lambda(_this__u8e3s4) {
  return _this__u8e3s4;
}
function renderListExpensive$lambda(_this__u8e3s4, it) {
  return _this__u8e3s4;
}
function renderListExpensiveAnimating$lambda(_this__u8e3s4, it) {
  return _this__u8e3s4;
}
var renderListExpensiveAnimating$2$1Class;
function renderListExpensiveAnimating$2$1() {
  if (renderListExpensiveAnimating$2$1Class === VOID) {
    class $ {
      constructor($this, $output) {
        this.$this_1 = $this;
        this.$output_1 = $output;
        this.$$delegate_0__1 = $this;
      }
      addChild_2qpft2_k$(element) {
        if (!(this.$output_1._v == null))
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Produced more than one element at this layer, but only one was expected.');
        this.$this_1.addChild_2qpft2_k$(element);
        this.$output_1._v = element;
      }
      get_context_h02k06_k$() {
        return this.$$delegate_0__1.get_context_h02k06_k$();
      }
      willAddChild_hz2iwc_k$(element) {
        this.$$delegate_0__1.willAddChild_hz2iwc_k$(element);
      }
      invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate) {
        return this.$$delegate_0__1.invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate);
      }
      get_coroutineContext_115oqo_k$() {
        return this.$$delegate_0__1.get_coroutineContext_115oqo_k$();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [KiteUiCoroutineScopeHelpers()]);
    renderListExpensiveAnimating$2$1Class = $;
  }
  return renderListExpensiveAnimating$2$1Class;
}
function renderListExpensiveAnimating$lambda$lambda($shown) {
  return ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$($shown);
}
var renderListKeyedAnimated$1$1Class;
function renderListKeyedAnimated$1$1() {
  if (renderListKeyedAnimated$1$1Class === VOID) {
    class $ {
      constructor($this, $output) {
        this.$this_1 = $this;
        this.$output_1 = $output;
        this.$$delegate_0__1 = $this;
      }
      addChild_2qpft2_k$(element) {
        if (!(this.$output_1._v == null))
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Produced more than one element at this layer, but only one was expected.');
        this.$this_1.addChild_2qpft2_k$(element);
        this.$output_1._v = element;
      }
      get_context_h02k06_k$() {
        return this.$$delegate_0__1.get_context_h02k06_k$();
      }
      willAddChild_hz2iwc_k$(element) {
        this.$$delegate_0__1.willAddChild_hz2iwc_k$(element);
      }
      invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate) {
        return this.$$delegate_0__1.invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate);
      }
      get_coroutineContext_115oqo_k$() {
        return this.$$delegate_0__1.get_coroutineContext_115oqo_k$();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [KiteUiCoroutineScopeHelpers()]);
    renderListKeyedAnimated$1$1Class = $;
  }
  return renderListKeyedAnimated$1$1Class;
}
function renderListKeyedAnimated$lambda$lambda($shown) {
  return ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$($shown);
}
function renderListKeyedAnimated$lambda$slambda($milliseconds, $shown) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay($milliseconds, $completion);
    $shown.set_value_v1vabv_k$(true);
    return Unit_instance;
  }), 1);
}
var renderListKeyedNoAnimation$1$$inlined$withoutAnimation$1Class;
function renderListKeyedNoAnimation$1$$inlined$withoutAnimation$1() {
  if (renderListKeyedNoAnimation$1$$inlined$withoutAnimation$1Class === VOID) {
    class $ {
      constructor($this, $output) {
        this.$this_1 = $this;
        this.$output_1 = $output;
        this.$$delegate_0__1 = $this;
      }
      addChild_2qpft2_k$(element) {
        if (!(this.$output_1._v == null))
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Produced more than one element at this layer, but only one was expected.');
        this.$this_1.addChild_2qpft2_k$(element);
        this.$output_1._v = element;
      }
      get_context_h02k06_k$() {
        return this.$$delegate_0__1.get_context_h02k06_k$();
      }
      willAddChild_hz2iwc_k$(element) {
        this.$$delegate_0__1.willAddChild_hz2iwc_k$(element);
      }
      invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate) {
        return this.$$delegate_0__1.invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate);
      }
      get_coroutineContext_115oqo_k$() {
        return this.$$delegate_0__1.get_coroutineContext_115oqo_k$();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [KiteUiCoroutineScopeHelpers()]);
    renderListKeyedNoAnimation$1$$inlined$withoutAnimation$1Class = $;
  }
  return renderListKeyedNoAnimation$1$$inlined$withoutAnimation$1Class;
}
function renderListKeyedNoAnimation$lambda$slambda($milliseconds, $shown) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay($milliseconds, $completion);
    $shown.set_value_v1vabv_k$(true);
    return Unit_instance;
  }), 1);
}
var renderListKeyedNoAnimation$1$$inlined$withoutAnimation$5Class;
function renderListKeyedNoAnimation$1$$inlined$withoutAnimation$5() {
  if (renderListKeyedNoAnimation$1$$inlined$withoutAnimation$5Class === VOID) {
    class $ {
      constructor($this, $output) {
        this.$this_1 = $this;
        this.$output_1 = $output;
        this.$$delegate_0__1 = $this;
      }
      addChild_2qpft2_k$(element) {
        if (!(this.$output_1._v == null))
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Produced more than one element at this layer, but only one was expected.');
        this.$this_1.addChild_2qpft2_k$(element);
        this.$output_1._v = element;
      }
      get_context_h02k06_k$() {
        return this.$$delegate_0__1.get_context_h02k06_k$();
      }
      willAddChild_hz2iwc_k$(element) {
        this.$$delegate_0__1.willAddChild_hz2iwc_k$(element);
      }
      invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate) {
        return this.$$delegate_0__1.invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate);
      }
      get_coroutineContext_115oqo_k$() {
        return this.$$delegate_0__1.get_coroutineContext_115oqo_k$();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [KiteUiCoroutineScopeHelpers()]);
    renderListKeyedNoAnimation$1$$inlined$withoutAnimation$5Class = $;
  }
  return renderListKeyedNoAnimation$1$$inlined$withoutAnimation$5Class;
}
function renderListKeyedNoAnimation$lambda$slambda_0($milliseconds, $shown) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay($milliseconds, $completion);
    $shown.set_value_v1vabv_k$(true);
    return Unit_instance;
  }), 1);
}
var atIndex$1Class;
function atIndex$1() {
  if (atIndex$1Class === VOID) {
    class $ {
      constructor($this_atIndex, $index) {
        this.$this_atIndex_1 = $this_atIndex;
        this.$index_1 = $index;
        this.$$delegate_0__1 = $this_atIndex;
      }
      addChild_2qpft2_k$(element) {
        this.$this_atIndex_1.addChild_51cm2s_k$(this.$index_1, element);
      }
      get_context_h02k06_k$() {
        return this.$$delegate_0__1.get_context_h02k06_k$();
      }
      willAddChild_hz2iwc_k$(element) {
        this.$$delegate_0__1.willAddChild_hz2iwc_k$(element);
      }
      invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate) {
        return this.$$delegate_0__1.invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate);
      }
      get_coroutineContext_115oqo_k$() {
        return this.$$delegate_0__1.get_coroutineContext_115oqo_k$();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [KiteUiCoroutineScopeHelpers()]);
    atIndex$1Class = $;
  }
  return atIndex$1Class;
}
//region block: exports
export {
  forEachAnimated as forEachAnimated2cqhhdwgrq6qu,
  forEachUpdating as forEachUpdating3is0lusemmftw,
  forEach as forEachxvppdmkkfnh7,
  renderListExpensive as renderListExpensive1uww6gegn7pye,
  renderListExpensive_0 as renderListExpensive2jy2o58jy5yrj,
  renderListKeyed as renderListKeyed2aa8xagnzn29y,
  renderList as renderList2ygesqkknbufi,
};
//endregion

//# sourceMappingURL=foreach.mjs.map
